import { getDimensionList, getKinkCategoryList } from "../../services/catalogService";

const PHYSICAL_DIMS = [
  { key: "body_types", label: "Tipo de cuerpo" },
  { key: "hair_colors", label: "Color de pelo" },
  { key: "eye_colors", label: "Color de ojos" },
  { key: "skin_colors", label: "Tono de piel" },
  { key: "ethnicities", label: "Etnia" },
];

const PARTNER_DIMS = [
  { key: "body_types", label: "Tipo de cuerpo" },
  { key: "hair_colors", label: "Color de pelo" },
  { key: "eye_colors", label: "Color de ojos" },
  { key: "ethnicities", label: "Etnia" },
];

function optionLabel(item) {
  if (item == null) return "";
  if (typeof item === "string") return item;
  return item.name != null ? String(item.name) : String(item.id ?? "");
}

function DimensionSelects({ dimensions, catalogData, values, onChange, isLoading, testIdPrefix }) {
  function addValue(name) {
    const n = String(name || "").trim();
    if (!n || values.includes(n)) return;
    onChange([...values, n]);
  }

  if (isLoading) {
    return (
      <p className="text-[10px] uppercase tracking-[0.2em] text-[rgba(255,255,255,0.45)]" data-testid={`${testIdPrefix}-loading`}>
        Cargando catálogo…
      </p>
    );
  }

  if (!catalogData) {
    return null;
  }

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2" data-testid={testIdPrefix}>
      {dimensions.map(({ key, label }) => {
        const list = getDimensionList(catalogData, key);
        if (list.length === 0) return null;
        return (
          <div key={key} className="space-y-1">
            <label className="zx-label" htmlFor={`${testIdPrefix}-${key}`}>
              Añadir — {label}
            </label>
            <select
              id={`${testIdPrefix}-${key}`}
              className="zx-input zx-select"
              defaultValue=""
              onChange={(e) => {
                const v = e.target.value;
                if (v) {
                  addValue(v);
                  e.target.value = "";
                }
              }}
              data-testid={`${testIdPrefix}-select-${key}`}
            >
              <option value="">Elegir…</option>
              {list.map((item) => {
                const opt = optionLabel(item);
                const id = item?.id != null ? String(item.id) : opt;
                return (
                  <option key={id} value={opt}>
                    {opt}
                  </option>
                );
              })}
            </select>
          </div>
        );
      })}
    </div>
  );
}

/** Selectores por dimensión + lista manual debajo (Características físicas). */
export function PhysicalCatalogPickers({ catalogData, values, onChange, isLoading, testIdPrefix = "catalog-physical" }) {
  return (
    <div className="space-y-3">
      <p className="text-[10px] uppercase tracking-[0.2em] text-[rgba(255,255,255,0.5)]">Desde catálogo</p>
      <DimensionSelects
        dimensions={PHYSICAL_DIMS}
        catalogData={catalogData}
        values={values}
        onChange={onChange}
        isLoading={isLoading}
        testIdPrefix={testIdPrefix}
      />
    </div>
  );
}

/** Preferencias de pareja (sin piel). */
export function PartnerCatalogPickers({ catalogData, values, onChange, isLoading, testIdPrefix = "catalog-partner" }) {
  return (
    <div className="space-y-3">
      <p className="text-[10px] uppercase tracking-[0.2em] text-[rgba(255,255,255,0.5)]">Desde catálogo</p>
      <DimensionSelects
        dimensions={PARTNER_DIMS}
        catalogData={catalogData}
        values={values}
        onChange={onChange}
        isLoading={isLoading}
        testIdPrefix={testIdPrefix}
      />
    </div>
  );
}

/** Gustos con categorías y kinks anidados. */
export function KinkCatalogPicker({ catalogData, values, onChange, isLoading, testIdPrefix = "catalog-kinks" }) {
  function addValue(name) {
    const n = String(name || "").trim();
    if (!n || values.includes(n)) return;
    onChange([...values, n]);
  }

  if (isLoading) {
    return (
      <p className="text-[10px] uppercase tracking-[0.2em] text-[rgba(255,255,255,0.45)]" data-testid={`${testIdPrefix}-loading`}>
        Cargando catálogo…
      </p>
    );
  }

  const categories = getKinkCategoryList(catalogData);
  if (!categories.length) return null;

  return (
    <div className="space-y-3" data-testid={testIdPrefix}>
      <p className="text-[10px] uppercase tracking-[0.2em] text-[rgba(255,255,255,0.5)]">Desde catálogo</p>
      <div className="space-y-1">
        <label className="zx-label" htmlFor={`${testIdPrefix}-kink`}>
          Añadir gusto
        </label>
        <select
          id={`${testIdPrefix}-kink`}
          className="zx-input zx-select"
          defaultValue=""
          onChange={(e) => {
            const v = e.target.value;
            if (v) {
              addValue(v);
              e.target.value = "";
            }
          }}
          data-testid={`${testIdPrefix}-select`}
        >
          <option value="">Elegir…</option>
          {categories.map((cat) => {
            const catLabel = cat?.name != null ? String(cat.name) : String(cat?.id ?? "");
            const kinks = Array.isArray(cat?.kinks) ? cat.kinks : [];
            if (kinks.length === 0) return null;
            return (
              <optgroup key={cat?.id ?? catLabel} label={catLabel}>
                {kinks.map((k) => {
                  const label = optionLabel(k);
                  const kid = k?.id != null ? String(k.id) : label;
                  return (
                    <option key={kid} value={label}>
                      {label}
                    </option>
                  );
                })}
              </optgroup>
            );
          })}
        </select>
      </div>
    </div>
  );
}
